<template>
  <div class="container-fluid fme-login-container">
    <div class="row fme-login-row">
      <div class="col-md-12 fme-login-col">
        <div class="row">
          <div class="col-md-12">
            <div class="fme-login-form">
              <div class="row">
                <div class="col-md-12 fme_no-padding">
                  <img src="@/assets/logointeiro-findme.png" />
                </div>
              </div>

              <div class="row fme-login-row__lines">
                <div class="col-md-12 fme_no-padding">
                  <p class="fme-login-title fme-hind-font">
                    Acesse com seu e-mail e senha disponibilizados pela Empresa:
                  </p>
                </div>
              </div>

              <p
                class="fm-input__error-msg fme-hind-font text-center"
                v-if="loginError.access !== ''"
              >
                {{ loginError.access }}
              </p>
              <div class="row fme-login-row__lines">
                <div class="col-md-12 fme_no-padding">
                  <input
                    v-model="inputUserEmail"
                    type="text"
                    id="id"
                    placeholder="EMAIL"
                    @keyup.enter="loginEvent"
                  />
                  <p
                    class="fm-input__error-msg fme-hind-font"
                    v-if="loginError.email !== ''"
                  >
                    {{ loginError.email }}
                  </p>
                </div>
              </div>

              <div class="row fme-login-row__lines">
                <div class="col-md-12 fme_no-padding">
                  <div class="fme-search__input-field--group">
                    <a @click.prevent="passwordEnable">
                      <font-awesome-icon
                        v-if="typePasswordField === 'text'"
                        icon="eye"
                        far
                        class="fme-login-form__password-icon"
                      />
                      <font-awesome-icon
                        v-else-if="typePasswordField === 'password'"
                        icon="eye-slash"
                        far
                        class="fme-login-form__password-icon"
                      />
                    </a>
                    <input
                      v-model="inputUserPassword"
                      :type="typePasswordField"
                      class="fme-hind-font"
                      id="senha"
                      placeholder="SENHA"
                      @keyup.enter="loginEvent"
                    />
                  </div>

                  <p
                    class="fm-input__error-msg fme-hind-font"
                    v-if="loginError.password !== ''"
                  >
                    {{ loginError.password }}
                  </p>
                </div>
              </div>

              <div class="row fme-login-row__lines">
                <div class="col-md-12 fme_no-padding">
                  <button
                    @click.prevent="loginEvent"
                    class="btn fme-btn fme-btn-login"
                  >
                    ENTRAR
                  </button>
                </div>
              </div>

              <div class="row fme-login-row__lines d-none">
                <div class="col-md-12 fme_no-padding">
                  <a
                    @click.prevent=""
                    class="fme-btn-forgot-password fme-montserrat-font"
                    >ESQUECI MINHA SENHA</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 fme-montserrat-font fme-login-email">
            <a href="mailto:suporte@findme.id">SUPORTE@FINDME.ID</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import axios from "axios";
import { fetchUser } from "../services/fetchUser";

export default {
  name: "TheNavbar",
  created() {
    this.logoutUser();
    this.clearAllState();
    this.clearModuleSupervisionState();
    this.clearModuleOverviewState();
    this.clearModuleMetricState();
    localStorage.setItem("vuex", "");
  },
  beforeDestroy() {
    this.changeErrors([]);
  },
  data() {
    return {
      inputUserEmail: "",
      inputUserPassword: "",
      loginError: {
        email: "",
        password: "",
        access: "",
      },
      typePasswordField: "password",
    };
  },
  computed: {
    ...mapGetters("ModuleErrors", ["errorsList"]),
  },
  methods: {
    ...mapActions([
      "changeAxiosHeaders1",
      "changeHeadersCrud",
      "changeCompanyName",
      "changeCompanyLogo",
      "changeCompanyStatus",
      "changeUserName",
      "changeUserEmail",
      "changeUserLocale",
      "changeUserCreatedAt",
      "clearAllState",
    ]),
    ...mapActions("ModuleErrors", ["changeErrors"]),
    ...mapActions("ModuleSupervision", ["clearModuleSupervisionState"]),
    ...mapActions("ModuleOverview", ["clearModuleOverviewState"]),
    ...mapActions("ModuleMetric", ["clearModuleMetricState"]),
    passwordEnable() {
      if (this.typePasswordField === "text") {
        this.typePasswordField = "password";
      } else if (this.typePasswordField === "password") {
        this.typePasswordField = "text";
      }
    },
    async loginEvent() {
      let urlLogin = process.env.VUE_APP_LOGIN_API;
      let userLogin = {
        email: this.inputUserEmail,
        password: this.inputUserPassword,
      };

      let userUUID

      try {
        let response = await axios.post(urlLogin, userLogin);
        localStorage.setItem("webBackoffice_token", response.data.data.token);
        localStorage.setItem("company_name", response.data.data.company.name);
        localStorage.setItem("user_name", response.data.data.user.name);
        localStorage.setItem("status", response.data.data.company.status);
        localStorage.setItem(
          "_findme_v3_base_url",
          process.env.VUE_APP_V3_BASE_URL
        );

        userUUID = response.data.data.user.uuid

        let companyName = response.data.data.company.name;
        let companyLogo = response.data.data.company.logo;
        let companyStatus = response.data.data.company.status;
        let userName = response.data.data.user.name;
        let userEmail = response.data.data.user.email;
        let userLocale = response.data.data.user.locale;
        let userCreatedAt = response.data.data.user.created_at;

        const newHeaders = {
          Authorization: `Bearer ${response.data.data.token}`,
        };

        this.changeAxiosHeaders1(newHeaders);
        this.changeCompanyName(companyName);
        this.changeCompanyLogo(companyLogo);
        this.changeCompanyStatus(companyStatus);
        this.changeUserName(userName);
        this.changeUserEmail(userEmail);
        this.changeUserLocale(userLocale);
        this.changeUserCreatedAt(userCreatedAt);

        this.$i18n.locale = userLocale;

        this.startApplication(userLocale);
      } catch (e) {
        let errorCode = e.response.status;
        let errorResponse = e.response.data;
        if (errorCode === 401 && errorResponse.error) {
          if (errorResponse.error.name === "UnknownUserEmailError") {
            this.changeErrors({
              email: "Email fornecido não foi encontrado",
            });
          } else if (errorResponse.error.name === "LoginRoleTypeClient") {
            this.changeErrors({
              access: "Perfil com cargo cliente não é permitido.",
            });
          } else if (
            errorResponse.error.name === "LoginCredentialsNotProvidedError"
          ) {
            this.changeErrors({
              email: "Email ou Identificador deve ser providenciado",
            });
          } else if (errorResponse.error.name === "InvalidUserPasswordError") {
            this.changeErrors({
              password: "Senha fornecida não é válida",
            });
          } else if (
            errorResponse.error.name === "LoginPasswordNotProvidedError"
          ) {
            this.changeErrors({
              password: "Senha deve ser providenciada",
            });
          } else if (errorResponse.error.name === "NonPayingCompaniesError") {
            this.changeErrors({
              access: "Acesso suspenso",
            });
          }
        }
      }

      try {
        let urlLoginV3Crud = process.env.VUE_APP_CRUD_URL_LOGIN;
        const CLIENT_ORIGIN = "origin=supervision";
        const response = await axios.post(
          `${urlLoginV3Crud}?${CLIENT_ORIGIN}`,
          { email: this.inputUserEmail, password: this.inputUserPassword }
        );

        const token = response.data.token

        const headersCrud = {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        };
        this.changeHeadersCrud(headersCrud);
        localStorage.setItem("_findme_v3_token", token);

        const user = await fetchUser(token, userUUID)
        localStorage.setItem("user_role", user.role);

        const pathToRedirectAfterLogin = localStorage.getItem("pathToRedirectAfterLogin")
        if (pathToRedirectAfterLogin) {        
          localStorage.removeItem("pathToRedirectAfterLogin")
          this.$router.push({ path: pathToRedirectAfterLogin });
        } else {
          this.$router.push({ name: "Home" });
        }
      } catch (error) {
        const {
          response: { data },
        } = error;
        if (data.error.name === "LoginRoleTypeClient") {
          this.changeErrors({
            access: "Perfil com cargo cliente não é permitido.",
          });
        }
      }
    },
  },
  filters: {},
  watch: {
    errorsList() {
      this.loginError.email = "";
      this.loginError.password = "";

      if (this.hasProperty(this.errorsList, "email")) {
        this.loginError.email = `${this.errorsList.email}`;
      }

      if (this.hasProperty(this.errorsList, "password")) {
        this.loginError.password = `${this.errorsList.password}`;
      }

      if (this.hasProperty(this.errorsList, "access")) {
        this.loginError.access = `${this.errorsList.access}`;
      }
    },
  },
};
</script>
<style lang="scss">
.fme-login-container {
  height: 100vh;
  vertical-align: middle;
  .fme-login-row {
    height: 100vh;
    background-image: url("~@/assets/header.png");
    .fme-login-col {
      height: 100vh;
      .fme-login-form {
        margin: 0 auto;
        margin-top: 5em;
        padding: 50px 38px 60px 38px;
        width: 380px;
        max-width: 380px;
        text-align: center;
        border-radius: 20px;
        background: $fme-color__write;
        -webkit-box-shadow: 0px 3px 10px 2px rgba(68, 149, 209, 0.3);
        -moz-box-shadow: 0px 3px 10px 2px rgba(68, 149, 209, 0.3);
        box-shadow: 0px 3px 10px 2px rgba(68, 149, 209, 0.3);
        .fme-login-row__lines {
          margin-top: 20px;
          .fme-login-title {
            font-size: 24px;
            color: $fme-color__dark-silver;
            margin-bottom: 0;
            font-weight: 300;
            line-height: 34px;
          }
        }
        .fme-login-row__lines:last-child {
          text-align: right;
        }
        .fme-search__input-field--group {
          position: relative;
          display: inline-block;
          width: 100%;
          .fme-login-form__password-icon {
            color: $fme-color__silver-chalice;
            position: absolute;
            right: 20px;
            top: 15px;
            font-size: 20px;
            color: $fme-color__yale-blue;
            cursor: pointer;
            &:hover {
              color: $fme-color__celestial-blue;
            }
          }
          input {
            padding-right: 55px;
          }
        }
        input {
          width: 100%;
          height: 50px;
          max-height: 50;
          padding-right: 20px;
          padding-left: 20px;
          border-radius: 5px;
          display: inline-block;
          border: 1px solid $fme-color__old-silver;
          overflow: visible;
          color: $fme-color__old-silver;
          &::placeholder {
            font-size: 18px;
            font-family: "Hind", sans-serif;
          }
          &.inputError {
            border: 1px solid $fme-color__rosso-corsa;
          }
        }
        .fm-input__error-msg {
          text-align: left;
          font-size: 14px;
          font-weight: 400;
          padding-left: 11px;
          padding-top: 4px;
          margin-bottom: 0;
          color: $fme-color__rosso-corsa;
        }
        .fme-btn-forgot-password {
          color: $fme-color__flame;
          font-size: 12px;
          font-weight: 700;
          cursor: pointer;
          &:hover {
            color: $fme-color__flame-dark;
          }
        }
      }
      .fme-login-email {
        text-align: center;
        font-size: 14px;
        font-weight: 700;
        margin-top: 30px;
        line-height: 24px;
        a {
          text-decoration: none;
          color: $fme-color__flame;
          &:hover {
            color: $fme-color__flame-dark;
          }
        }
      }
    }
  }
}
</style>
